<template>
  <div class="right-content">
    <div class="right-top">
      <div class="header">
        <div class="title" @click="pushRouter('exam/index')">考核整改</div>
      </div>
      <div class="examResult-table">
        <ul class="list-title">
          <li>
            <p class="examResult-table-no" title="序号">序号</p>
            <p class="examResult-table-name" title="企业名称">企业名称</p>
            <p class="examResult-table-date" title="日期">日期</p>
            <p class="examResult-table-score" title="分数">分数</p>
          </li>
        </ul>
        <vue-seamless-scroll
          :data="examResultData"
          class="seamless-warp"
          :class-option="optionSetting"
        >
          <ul class="scoll-main">
            <li
              class="main-list"
              v-for="(item, index) in examResultData"
              :key="index"
            >
              <p class="examResult-table-no" :title="item.index">
                {{ index + 1 }}
              </p>
              <p class="examResult-table-name" :title="item.companyName">
                {{ item.companyName }}
              </p>
              <p class="examResult-table-date" :title="item.date">
                {{ $dayjs(item.date).format("YYYY-MM-DD") }}
              </p>
              <p class="examResult-table-score" :title="item.score">
                {{ item.score }}
              </p>
            </li>
          </ul>
        </vue-seamless-scroll>
      </div>
    </div>
    <div class="right-bottom">
      <div class="header">
        <div class="title" @click="pushRouter('monitor/index')">实时监控</div>
      </div>
      <div class="content">
        <img src="../assets/images/jk.jpg" style="width: 100%; height: 100%" />
      </div>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: { vueSeamlessScroll },
  data() {
    return {
      examResultData: [],
    };
  },
  computed: {
    optionSetting() {
      return {
        step: 0.1, // 数值越大速度滚动越快
        // limitMoveNum: 8, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 30, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 50, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  methods: {
    pushRouter(src) {
      this.$router.push(src);
    },
    getExamResult() {
      const url = this.$api.cockpit.getExamResult;
      let params = {};
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          this.examResultData = res.data.data;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
  },
  mounted() {
    this.getExamResult();
  },
};
</script>

<style lang="scss" scoped>
.right-content {
  width: 100%;
  height: 100%;
  padding-right: 10px;

  .right-top {
    width: 100%;
    height: calc(50% - 10px);
    margin-bottom: 20px;
    border: 2px solid #1b4498;
    border-radius: 8px;
    padding: 0px 10px;

    .header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      margin-top: 5px;

      .title {
        font-size: 18px;
        cursor: pointer;
      }

      .tags {
      }
    }

    .examResult-table {
      height: calc(100% - 100px);
    }

    .seamless-warp {
      height: calc(100% - 20px);
      overflow: hidden;
    }

    .examResult-table-no {
      width: 40px;
    }

    .examResult-table-name {
      flex: 1;
    }

    .examResult-table-score {
      width: 50px;
    }

    .examResult-table-date {
      flex: 1;
    }

    .list-title {
      margin-bottom: 10px;

      li {
        display: flex;
      }
    }

    .main-list {
      display: flex;
      padding: 6px 0px;

      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-right: 5px;
      }
    }
  }

  .right-bottom {
    width: 100%;
    height: calc(50% - 10px);
    margin-bottom: 20px;
    border: 2px solid #1b4498;
    border-radius: 8px;

    padding: 0px 10px;

    .header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      margin-top: 5px;

      .title {
        font-size: 18px;
        cursor: pointer;
      }

      .tags {
      }
    }

    .content {
      text-align: center;
      // height: 200px;
      height: calc(100% - 55px);
      line-height: 200px;
    }
  }
}
</style>